/* eslint-disable jsx-a11y/interactive-supports-focus */
import React from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';

const ShareWith = (props) => {

  const { metaData, type = 'facebook' } = props;

  const { title, description, img, url, host } = metaData;

  const specification = {
    facebook: {
      baseUrl: 'https://www.facebook.com/sharer.php?u=',
      target: '',
      features: 'menubar=no,toolbar=no,resizable=no,scrollbars=no,height=200,width=600',
      classIcon: 'fa fa-facebook',
    },
    whatsapp: {
      baseUrl: 'https://api.whatsapp.com/send?text=',
      target: '_blanck',
      features: '',
      classIcon: 'fa fa-whatsapp',
    },
  };

  const urlShare = new URL(`${host}/share-facebook.php?`
    + `title=${title
    }&description=${description
    }&img=${img
    }&url=${url}`);

  const urlEncoded = encodeURIComponent(urlShare);

  const encoded = urlShare !== '' ? urlEncoded : encodeURIComponent(document.URL);

  const handleClick = () => {
    isClient && window.open(
      specification[type].baseUrl + encoded,
      specification[type].target,
      specification[type].features,
    );
  };

  return (
    <span
      role='button'
      onClick={handleClick}
      className='back-icon border-color-dinamico'
    >
      <i className={`${specification[type].classIcon} color-dinamico`} />
    </span>
  );
};

export default ShareWith;
